const GraphObjects = [];
const setGraphData = (state = GraphObjects, action) => {
    if(action.type === "SET_GRAPH_OBJECTS"){
        state =  action.graphData
        
    }
    return state;
}

export default setGraphData;